export default __webpack_public_path__ + "static/media/cha_medic_tuye.ac48e73c.png";